import React from 'react'

export default class Description extends React.Component {
  render () {
    return (
      <p className="dotted-bottom">Enter the Subtotal, Tip and Tax listed at the bottom of the receipt.</p>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/components/Description.js
 **/